export const TABLE_HEADERS = [
  {
    display: 'Download',
    id: 'download',
  },
  {
    display: 'Name',
    id: 'network',
  },
  {
    display: 'MD5 Checksum (Base64)',
    id: 'checksum',
  },
  {
    display: 'Size',
    id: 'size',
  },
  {
    display: 'Date',
    id: 'date',
  },
  {
    display: 'Block',
    id: 'block',
  },
  {
    display: 'Version',
    id: 'version',
  },
  {
    display: 'Indexed',
    id: 'indexed',
  },
];
